type CompactNumberInput = number | string | null | undefined;

const stripTrailingZeros = (num: string): string => {
  if (num.endsWith('.00')) return num.slice(0, -3);
  if (num.includes('.')) return num.replace(/\.?0+$/, '');
  return num;
};

const parseCompactNumber = (value: CompactNumberInput): number | null => {
  if (value == null || value === '') return null;

  const parsed =
    typeof value === 'number'
      ? value
      : Number(String(value).replace(/,/g, ''));

  return Number.isFinite(parsed) ? parsed : null;
};

/**
 * Formats large numbers into compact notation: 298, 1.5K, 34M, 1.2B
 */
export function formatCompactNumber(value: CompactNumberInput): string {
  const number = parseCompactNumber(value);
  if (number === null) return '';

  const abs = Math.abs(number);
  const sign = number < 0 ? '-' : '';

  if (abs < 1000) {
    return `${sign}${Number.isInteger(abs) ? abs : stripTrailingZeros(abs.toFixed(2))}`;
  }

  if (abs < 1_000_000) {
    const formatted = stripTrailingZeros((abs / 1_000).toFixed(2));
    return `${sign}${formatted}K`;
  }

  if (abs < 1_000_000_000) {
    const formatted = stripTrailingZeros((abs / 1_000_000).toFixed(2));
    return `${sign}${formatted}M`;
  }

  const formatted = stripTrailingZeros((abs / 1_000_000_000).toFixed(2));
  return `${sign}${formatted}B`;
}

export default formatCompactNumber;
